import { render, staticRenderFns } from "./select_under_review.vue?vue&type=template&id=57532713&scoped=true&"
import script from "./select_under_review.vue?vue&type=script&lang=js&"
export * from "./select_under_review.vue?vue&type=script&lang=js&"
import style0 from "./select_under_review.vue?vue&type=style&index=0&id=57532713&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57532713",
  null
  
)

export default component.exports